import React from 'react';
import SingleColumnTemplate from '@templates/SingleColumn';
import Date from '@components/Date';
import { Button } from '@input';
import styles from './Publications.module.scss';
import RawHTML from '@components/RawHTML';

export default function Publications({
  items: _items,
  intro: _intro,
  data,
  ...restProps
}) {
  const intro = _intro ?? <RawHTML>{data?.markdownRemark?.html}</RawHTML>;
  const items =
    _items ?? data?.markdownRemark?.frontmatter?.publications ?? [];

  return (
    <SingleColumnTemplate
      h1="Publications"
      {...restProps}
    >
      {intro}
      {items && (
        <ol
          className={styles.list}
          style={{ counterReset: `num ${items.length + 1}` }}
        >
          {items.map((item, index) => (
            <Publication
              key={index}
              {...item}
            />
          ))}
        </ol>
      )}
    </SingleColumnTemplate>
  );
}

function Publication({ title, date, author, text_md: text, links }) {
  return !title ? null : (
    <li>
      {(date || author) && (
        <div className={styles.info}>
          <Date
            value={date}
            className={styles.date}
          />
          <span className={styles.author}>{author}</span>
        </div>
      )}
      <h2>{title}</h2>
      {text && (
        <div className={styles.text}>
          <RawHTML>{text}</RawHTML>
        </div>
      )}
      {!!links?.length && (
        <div className={styles.links}>
          {links.map(({ link }, index) => {
            const { text, url, file } = link;
            const to = url ? url : file?.publicURL;

            return !to || !text ? null : (
              <Button
                href={to}
                key={index}
                size="small"
                target="_blank"
              >
                {text}
              </Button>
            );
          })}
        </div>
      )}
    </li>
  );
}
